import { apiGet, apiPost } from './client';

/** Client for /api/fbc-assignments — FBCs claim their own partners (#243). */

export type FbcRef = { name: string; email: string };

export type FbcPartnerAf = { af: string; fbc: FbcRef | null; sourceFbc: FbcRef | null; overridden: boolean };

export type FbcPartnerRow = { key: string; name: string; marketingNames: string[]; afs: FbcPartnerAf[] };

export type FbcAssignmentsResponse = {
  me: FbcRef | null;
  canAssignAnyone: boolean;
  source: 'zoho' | 'pulse';
  fbcs: FbcRef[];
  partners: FbcPartnerRow[];
};

export const fbcAssignmentsApi = {
  list: () => apiGet<FbcAssignmentsResponse>('/api/fbc-assignments'),
  /** FBC: claim for yourself. Admin: assign to fbcEmail, or null to unassign. */
  assign: (partnerKey: string, fbcEmail?: string | null) =>
    apiPost<{ ok: true }>('/api/fbc-assignments/assign', { partnerKey, fbcEmail }),
  release: (partnerKey: string) => apiPost<{ ok: true }>('/api/fbc-assignments/release', { partnerKey }),
  reset: (partnerKey: string) => apiPost<{ ok: true }>('/api/fbc-assignments/reset', { partnerKey }),
};
